export default class PlaceholderEvent {
    constructor(type) {
        this.type = type;
    }
}

PlaceholderEvent.CLOSE_REQUEST = "PlaceholderEvent.CLOSE_REQUEST";